export default () => {
  return {

    // Product
    productLoaded: false,
    productName: null,
    productPrice: null,

    // Header
    headerAlignment: 'left',
    productNameEnabled: true,
    productPriceEnabled: true,

    // Gamepad
    gamepadButtonsColor: '1500AF',
    arButtonEnabled: true,
    resetButtonEnabled: true,
    dimensionsButtonEnabled: true,
    screenshotButtonEnabled: true,

    // AR
    arLoading: false,

    // Glances
    glancedOptionsItem: null,

    // Error
    errorDisplayed: false,
    errorMessage: null,
  }
}
